import type { IconType } from 'react-icons';
import { FaWalking } from 'react-icons/fa';
import { BiDumbbell } from 'react-icons/bi';
import { MdDirectionsRun, MdSettings } from 'react-icons/md';
import { PiPersonSimpleHikeFill } from 'react-icons/pi';
import { TbBikeFilled, TbStretching, TbSwimming } from 'react-icons/tb';
import { MdRowing } from 'react-icons/md';
import { getSportIconMeta, type SportIconKey } from '@trainme/api/client';

interface Props {
  type?: string;
  withColor?: boolean;
  className?: string;
  size?: number;
}

const iconMap: Record<SportIconKey, { icon: IconType }> = {
  run: { icon: MdDirectionsRun },
  ride: { icon: TbBikeFilled },
  swim: { icon: TbSwimming },
  rowing: { icon: MdRowing },
  weightTraining: { icon: BiDumbbell },
  yoga: { icon: TbStretching },
  walk: { icon: FaWalking },
  hike: { icon: PiPersonSimpleHikeFill },
  other: { icon: MdSettings },
};

export default function SportIcon({
  type,
  withColor,
  className,
  size = 16,
}: Props) {
  if (withColor === undefined) withColor = true;

  const { icon: iconKey, color } = getSportIconMeta(type);
  const iconEntry = iconMap[iconKey];

  if (!iconEntry) return null;

  const IconComponent = iconEntry.icon;
  return (
    <IconComponent
      size={size}
      className={className}
      style={{ color: withColor ? color : undefined }}
    />
  );
}
